// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

export { log } from "./log.common.js";
